// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-74c1da6d] .van-nav-bar__left .tit-left,[data-v-74c1da6d] .van-nav-bar__right .tit-right{color:#fff}", ""]);
// Exports
module.exports = exports;
